import initialState from "./roadClosureAlert.state.js";
import actions from "./roadClosureAlert.actions.js";
import mutations from "./roadClosureAlert.mutations.js";
import getters from "./roadClosureAlert.getters.js";

export default {
  state: initialState,
  actions,
  mutations,
  getters
};
